const reportingConstants = {
  OPERATORS_REPORTING: 'operators',
  FOLDERS_REPORTING: 'folders',
  FOLDER_LIST_REPORTING: 'folder_list',
  ERGOS_REPORTING: 'ergo',
};

export default reportingConstants;
